import TomSelect from "tom-select"
import { ingredientSearchResult } from "./ingredient_search_result"

export default class ProductFilterIngredientSelector {
    constructor(selectElement) {
        this.selectElement = selectElement
        this.initialize()
    }

    initialize() {
        if (this.selectElement.tomselect) {
            return this.selectElement.tomselect
        }

        this.createTomSelect()
    }

    createTomSelect() {
        // Signed-out visitors (and crawlers) rarely open the ingredient filter, so
        // defer the search request until the field is focused rather than preloading
        // on page load. Signed-in users keep the eager preload for instant results.
        const signedIn = document.querySelector('meta[name="turbo:authenticated"]')?.content === "true"
        const includeGroups = this.includeGroups()

        // Preselected ingredients arrive as server-rendered <option selected>
        // elements, which TomSelect imports on initialization.
        this.selectElement.tomselect = new TomSelect(this.selectElement, {
            valueField: "id",
            labelField: "text",
            searchField: [],
            // Keep the server's ordering (groups first, then relevance).
            // Results carry no client-side sort key, and sifter's cmp falls
            // back to string comparison against undefined for missing fields,
            // which scrambles any field-based sort.
            sortField: [{ field: "$order", direction: "asc" }],
            diacritics: true,
            preload: signedIn ? true : "focus",
            closeAfterSelect: true,
            loadThrottle: 200,
            maxItems: 10,
            plugins: ["remove_button"],
            load: function (query, callback) {
                this.clearOptions()
                let url = `/ingredients/search.json?search[term]=${encodeURIComponent(query)}`
                if (includeGroups) {
                    url += "&search[include_groups]=true"
                }
                fetch(url)
                    .then((response) => response.json())
                    .then((json) => callback(json))
                    .catch(() => callback())
            },
            render: {
                option: function (item, escape) {
                    return ingredientSearchResult(item.text, { group: !!item.group })
                },
            },
        })
    }

    // Group entries ("Hyaluronic Acid (all forms)") are only offered where the
    // select opts in, currently the excluded-ingredient filter.
    includeGroups() {
        return this.selectElement.dataset.includeGroups === "true"
    }

    destroy() {
        if (this.selectElement.tomselect) {
            this.selectElement.tomselect.destroy()
        }
    }
}
